import { ActionContextBasic } from '../index'
import { RecordType, RecordTypeMaster } from '@/modules/RecordType/interfaces/record-type'
import { Snack, SnackType } from '@/interfaces/snack'

export interface State {
  recordTypes: RecordType[]
}

const state = () => ({
  recordTypes: []
})

const getters = {
  policyRecordTypes: (state: State) => {
    return state.recordTypes.filter(rt => rt.master === RecordTypeMaster.POLICY)
  },
  accountRecordTypes: (state: State) => {
    return state.recordTypes.filter(rt => rt.master === RecordTypeMaster.ACCOUNT)
  },
  contactRecordTypes: (state: State) => {
    return state.recordTypes.filter(rt => rt.master === RecordTypeMaster.CONTACT)
  }
}

const mutations = {
  UPDATE_RECORD_TYPES (state: State, val: RecordType[]) {
    state.recordTypes = val
  }
}

const actions = {
  updateRecordTypes: (context: ActionContextBasic, val: RecordType[]) => {
    context.commit('UPDATE_RECORD_TYPES', val)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
